module.exports = __webpack_public_path__ + "static/media/HealthTech_1.18cdca05.gif";